import { render, staticRenderFns } from "./Boletines.vue?vue&type=template&id=73da5346"
import script from "./Boletines.vue?vue&type=script&lang=js"
export * from "./Boletines.vue?vue&type=script&lang=js"
import style0 from "./Boletines.vue?vue&type=style&index=0&id=73da5346&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports